import { ICurrency } from "../../models/ICurrency";

export class CurrencyState {
  currency: ICurrency[] = [];
}
